// Real Epic Memories event photos (uploaded)
export const REAL = {
  gameSelfie: "https://customer-assets-wrfwihn1.emergentagent.net/job_luxury-events-ar/artifacts/5yno7pph_IMG_20260718_105053%20%2815%29.jpg",
  event2: "https://customer-assets-wrfwihn1.emergentagent.net/job_luxury-events-ar/artifacts/zgxmeba9_IMG_20260718_105810%20%286%29.webp",
  event3: "https://customer-assets-wrfwihn1.emergentagent.net/job_luxury-events-ar/artifacts/a87bnklc_IMG_20260718_105810%20%283%29.webp",
  paintCanvas: "https://customer-assets-wrfwihn1.emergentagent.net/job_luxury-events-ar/artifacts/qa63udcu_IMG_20260718_105811%20%281%29.webp",
  boombox: "https://customer-assets-wrfwihn1.emergentagent.net/job_luxury-events-ar/artifacts/7i1qriec_Messenger_creation_9C34B34E-3ABF-4DC7-B8F5-657DB1DA5527.webp",
};

export const STOCK = {
  hero: "https://images.pexels.com/photos/16120220/pexels-photo-16120220.jpeg",
  paintSip: "https://images.unsplash.com/photo-1723408778833-75cde5f11d50?crop=entropy&cs=srgb&fm=jpg&q=85",
  wedding: "https://images.pexels.com/photos/29040997/pexels-photo-29040997.jpeg",
};

export const SERVICES = [
  { t: "Weddings", d: "Timeless ceremonies designed down to the last golden detail.", tall: true },
  { t: "Paint & Sip", d: "Brushes, bevvies and big energy.", img: STOCK.paintSip },
  { t: "TrapN Paint", d: "Hip-hop meets fine art — our signature night." },
  { t: "R&B Night", d: "Grown, sexy and smooth all evening." },
  { t: "Corporate Events", d: "Polished galas, launches & mixers." },
  { t: "Game Nights", d: "Dominoes, spades and pure vibes.", img: null },
  { t: "Birthday Parties", d: "Milestones turned into moments." },
  { t: "Fashion Shows", d: "Runways with culture and couture.", tall: true },
  { t: "Charity Fundraisers", d: "Purpose-driven, unforgettable galas." },
  { t: "Baby Showers", d: "Sweet, styled celebrations of new life." },
  { t: "Bridal Showers", d: "Chic send-offs for the bride-to-be." },
  { t: "Private Parties", d: "Intimate, invite-only experiences." },
  { t: "Event Decorating", d: "Balloon arches, backdrops & tablescapes." },
  { t: "Day-of Coordination", d: "We run the show so you can enjoy it." },
];

export const CHAPTERS = [
  { n: "01", t: "Rooted in Community", d: "Epic Memories LLC is a Black woman-owned event company in Little Rock, Arkansas, built to bring people together through creativity, culture and celebration." },
  { n: "02", t: "Affordable Luxury", d: "We believe unforgettable shouldn't be unattainable. Every event is designed to feel high-end while staying within reach." },
  { n: "03", t: "Culture Forward", d: "From TrapN Paint to R&B Nights, our experiences are bold, fun and unapologetically inspired by the culture we love." },
  { n: "04", t: "Every Detail, Epic", d: "Coordination, decor, themes and vibes — we sweat the details so your only job is to make memories." },
];

export const GALLERY = [
  { src: REAL.gameSelfie, cat: "Game Nights" },
  { src: REAL.paintCanvas, cat: "Paint Parties" },
  { src: REAL.event3, cat: "Paint Parties" },
  { src: REAL.event2, cat: "Community Events" },
  { src: REAL.boombox, cat: "Community Events" },
  { src: STOCK.wedding, cat: "Weddings" },
  { src: STOCK.paintSip, cat: "Paint Parties" },
  { src: STOCK.hero, cat: "Corporate Events" },
];
export const GALLERY_CATS = ["All", "Paint Parties", "Weddings", "Corporate Events", "Community Events", "Fashion Shows", "Game Nights"];

export const TESTIMONIALS = [
  { q: "Epic Memories turned our game night into the event of the year. Creative, professional and so affordable!", n: "Tasha R.", r: "Game Night Host" },
  { q: "The TrapN Paint event was everything. The vibe, the art, the culture — pure magic.", n: "Marcus D.", r: "Paint & Sip Guest" },
  { q: "They coordinated our whole wedding day flawlessly. We just showed up and enjoyed it.", n: "Jasmine & Kevin", r: "Wedding Clients" },
  { q: "Affordable luxury is real. Our corporate mixer looked like a five-figure production.", n: "Danielle P.", r: "Corporate Client" },
];

export const FAQS = [
  { q: "What areas do you serve?", a: "We are based in Little Rock, Arkansas and serve the greater Central Arkansas area. Travel can be arranged for larger events." },
  { q: "How far in advance should I book?", a: "We recommend booking 4–8 weeks ahead for parties and 4–6 months for weddings, though we happily accommodate last-minute requests when available." },
  { q: "Do you offer affordable packages?", a: "Absolutely. Affordable luxury is our whole mission. We build custom packages to fit a range of budgets." },
  { q: "Can I buy tickets to your public events?", a: "Yes! Check our Event Calendar and tap Buy Tickets to grab your spot on Eventbrite." },
  { q: "Do you offer decorating only?", a: "Yes — from balloon arches to full tablescapes, we offer standalone event decorating and day-of coordination." },
];

export const BLOG = [
  { t: "5 Themes That Made Our Paint Parties Legendary", c: "Event Tips", d: "From Hip-Hop Game Night to Glow parties — here's how a strong theme elevates everything." },
  { t: "How to Plan a Wedding on an Affordable Luxury Budget", c: "Weddings", d: "Our coordinators share the secrets to a high-end look without the high-end price tag." },
  { t: "Why Community Events Matter in Little Rock", c: "Community", d: "Celebration is culture. Here's how we bring people together." },
];

export const EVENT_TYPES = SERVICES.map((s) => s.t);
